module.exports = __webpack_public_path__ + "img/130-00-CMS 16_9.192bc56b.png";